module.exports = __webpack_public_path__ + "bab561bc88b05ad11e2fb1f6f4f23a0a.png";